import canSeeIntegration from 'modules/marketplace/lib/canSeeIntegration'
import integrationCodes, { IntegrationCodesTypes } from 'modules/marketplace/lib/integrationCodes'
import { CompanyInstallations } from 'modules/marketplace/store/collections/companyInstallations'

/* This class is singleton to avoid one fetch per supplement in the payroll supplement page*/
class CompanyInstallationsChecker {
  collectionPromise?: Promise<CompanyInstallations> = undefined
  collection?: CompanyInstallations = undefined

  async isDatevApiInstalled(): Promise<boolean> {
    this.initializeCompanyInstallations()
    return this.checkInstallation(integrationCodes.datev_api)
  }

  async isDatevLugInstalled(): Promise<boolean> {
    this.initializeCompanyInstallations()
    return this.checkInstallation(integrationCodes.datev_lug_api)
  }

  async isDatevLaudsInstalled(): Promise<boolean> {
    this.initializeCompanyInstallations()
    return this.checkInstallation(integrationCodes.datev_lauds_factorial)
  }

  private async checkInstallation(integration: IntegrationCodesTypes): Promise<boolean> {
    await this.collectionPromise
    const installation = canSeeIntegration(integration, this.collection!)
    return Boolean(installation)
  }

  private async fetchCompanyInstallations(): Promise<CompanyInstallations> {
    this.collection = new CompanyInstallations()

    return this.collection.fetch()
  }

  private initializeCompanyInstallations() {
    if (!this.collection) {
      this.collectionPromise = this.fetchCompanyInstallations()
    }
  }
}

const singleton: CompanyInstallationsChecker = new CompanyInstallationsChecker()

export default singleton
